/**
 * Deep links to the Mixpanel reports each placeholder card is waiting on.
 *
 * These are links only — this tool makes no Mixpanel API call. Every metric
 * sourced from here is a placeholder on this pass, because no Mixpanel Query
 * API service account exists yet (the tokens the backend holds are ingest-only).
 * The links let an admin open the real number in one click in the meantime.
 */

const PROJECT_ID = "2377164";

const base = `https://mixpanel.com/project/${PROJECT_ID}/app`;

export const mixpanelLink = {
  insights: (reportId: string) => `${base}/insights#report/${reportId}`,
  funnels: (reportId: string) => `${base}/funnels#report/${reportId}`,
  board: (boardId: string) => `${base}/boards#id=${boardId}`,
};

/** Board IDs, for the metrics whose specific report ID isn't resolvable. */
export const MIXPANEL_BOARD = {
  kpis: "1597619",
  retention: "6308821",
  otherImportantMetrics: "1597651",
  errorMonitoring: "9948311",
};

export const STRIPE_DASHBOARD = "https://dashboard.stripe.com/";
export const TWILIO_USAGE = "https://console.twilio.com/us1/monitor/usage/summary";
